/* import __COLOCATED_TEMPLATE__ from './ai-agent-found-no-answer.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import { truncateEventText, isEventTextTruncated } from 'embercom/lib/inbox2/event-text-truncation';

interface Args {
  part: any;
}

export default class AiAgentFoundNoAnswer extends Component<Args> {
  @service declare session: Session;

  truncateTitle(title: string | undefined): string {
    return truncateEventText(title);
  }

  isTitleTruncated(title: string | undefined): boolean {
    return isEventTextTruncated(title);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::AiAgentFoundNoAnswer': typeof AiAgentFoundNoAnswer;
    'inbox2/conversation-stream/event-parts/ai-agent-found-no-answer': typeof AiAgentFoundNoAnswer;
  }
}
